export default __webpack_public_path__ + "static/media/Ubiquiti-screenshot.d922209c.jpg";